export default {
  menu: {
    analytics: 'Analytique',
    prototype: 'Fonctionnalités en prototype',
    candidateSearch: 'Recherche de candidat',
    managementOverview: "Vue d'ensemble",
  },
  tooltip: {
    dashboard: 'Liste des tâches du jour',
    jobs: 'Postes',
    calendar: 'Calendrier',
    messaging: 'Messagerie',
    menu: 'Menu',
    notification: 'Notifications',
  },
};
